import { translate } from "app/filters/i18nFilter";
import { COMPANY_ANALYSIS_DIGITAL_ASSETS } from "app/pages/sales-intelligence/constants/routes";
import CardFooter from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardFooter/CardFooter";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";
import { CardErrorBoundary } from "app/pages/sales-intelligence/pages/company-analysis/components/shared/CardErrorBoundary/CardErrorBoundary";
import { DigitalAssetsCard } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/DigitalAssetsCard/DigitalAssetsCard";
import { EmptyState } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/DigitalAssetsCard/EmptyState";

const DigitalAssetsCardWithErrorBoundary = () => (
    <CardErrorBoundary
        dataAutomation="digital-assets-card"
        header={
            <CardHeader
                title={translate("si.company-analysis.digital-assets.card.header")}
                infoTooltip={translate("si.company-analysis.digital-assets.card.header.tooltip")}
            />
        }
        footer={<CardFooter stateId={COMPANY_ANALYSIS_DIGITAL_ASSETS} />}
        width="50%"
        fallbackContent={<EmptyState />}
    >
        <DigitalAssetsCard />
    </CardErrorBoundary>
);

export default DigitalAssetsCardWithErrorBoundary;
